import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import PureSettings from '../../PureSettings.jsx/index.jsx'

export default function AdmissionSettings({ show, value, editMode }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [admissionSettingsUpdated, setAdmissionSettingsUpdated] = useState(false)
  const [admissionSetting, setAdmissionSetting] = useState('automatic-approval')
  const { loading, groupInfo, editSuccess, privacySetting } = useSelector((state) => state.createUpdateGroup)

  useEffect(() => {
    if (editMode && editSuccess) {
      if (admissionSettingsUpdated) {
        setAdmissionSettingsUpdated(false)
      }
    }
  }, [editSuccess])

  useEffect(() => {
    setAdmissionSetting(value)
  }, [value])

  const handleAdmissionSettingChange = (setting) => {
    if (setting === 0) {
      setAdmissionSetting('need-approval')
    } else if (setting === 1) {
      setAdmissionSetting('automatic-approval')
    }
    dispatch(createUpdateGroupActions.setAdmissionSetting(setting))
    setAdmissionSettingsUpdated(true)
  }

  const handleSave = () => {
    dispatch(
      createUpdateGroupActions.editGroup(groupInfo.id, {
        privacy_setting: privacySetting,
        automatic_approval_to_join: admissionSetting === 'automatic-approval' ? 1 : 0
      })
    )
  }
  const handleCancel = () => {
    setAdmissionSetting(groupInfo.automatic_approval_to_join === 1 ? 'automatic-approval' : 'need-approval')
    setAdmissionSettingsUpdated(false)
  }

  return (
    <PureSettings
      show={show}
      title={t('group.createGroup.advanceSetting.admission.title')}
      settings={[
        {
          key: 'need-approval',
          text: t('group.createGroup.advanceSetting.admission.option1'),
          value: 0,
          iconName: 'hat',
          aboutText: t('group.createGroup.advanceSetting.admission.option1Desc'),
          isSelected: admissionSetting === 'need-approval'
        },
        {
          key: 'automatic-approval',
          text: t('group.createGroup.advanceSetting.admission.option2'),
          value: 1,
          iconName: 'smiley-glad',
          aboutText: t('group.createGroup.advanceSetting.admission.option2Desc'),
          isSelected: admissionSetting === 'automatic-approval'
        }
      ]}
      actionButtons={{
        show: editMode && admissionSettingsUpdated,
        saveText: t('global.save'),
        cancelText: t('global.cancel')
      }}
      isSaving={loading}
      handleChange={handleAdmissionSettingChange}
      handleSave={handleSave}
      handleCancel={handleCancel}
    />
  )
}
